import Container from '@mui/material/Container/Container';
import Paper from '@mui/material/Paper/Paper';
import { SxProps, Theme } from '@mui/material/styles';
import React from 'react';

/**
 * Standard page wrapper. "surface" puts content on a card over the page background;
 * "plain" leaves layout to the page (for pages composed of their own cards).
 */
export const PageContainer = ({
    className,
    sx,
    variant = 'surface',
    children
}: {
    className?: string,
    sx?: SxProps<Theme>,
    variant?: 'surface' | 'plain',
    children: React.ReactNode
}) => {
    if (variant === 'plain') {
        return (
            <Container className={className} sx={sx}>
                {children}
            </Container>
        )
    }

    return (
        <Container className={className}>
            <Paper variant="outlined" sx={{
                borderRadius: '16px',
                p: { xs: 2, md: 4 },
                ...sx
            } as SxProps<Theme>}>
                {children}
            </Paper>
        </Container>
    )
}
